import styled from 'styled-components';
import Text12 from '@sdk/components/ui/typography/Text12';
import gettext, { ngettext } from '@sdk/lang/gettext';
import Href from '@sdk/components/ui/Href';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import { AuthUserType } from '@sdk/authentication/types/AuthUserType';

const StyledDiv = styled.div`
  font-weight: 600;
`;

type Props = {
  currentUser: AuthUserType;
  goToBilling: () => void;
};

const TrialInfo = ({ currentUser, goToBilling }: Props) => {
  const {
    isOnTrial,
    isTrialExpired,
    subscriptionStartDate,
    subscriptionCancelDate,
    subscriptionLevel,
    trialDaysLeft,
  } = currentUser.org;
  const wasPurchasedAtLeastOnce = Boolean(
    (subscriptionStartDate && subscriptionLevel) || subscriptionCancelDate
  );

  if (!currentUser.isManager) {
    return null;
  }

  const viewPlans = (): void => {
    goToBilling();
  };

  if (wasPurchasedAtLeastOnce) {
    return null;
  }

  return (
    <StyledDiv>
      <div>
        {isOnTrial && (
          <Href themeColor={ThemeColorType.white} fontSize={12} onClick={viewPlans}>
            {ngettext(
              'Your trial ends in 1 day',
              'Your trial ends in %(numberOfDays)s days',
              trialDaysLeft,
              { numberOfDays: trialDaysLeft }
            )}
          </Href>
        )}
      </div>
      {isTrialExpired && (
        <Text12 fontWeight={'600'} themeColor={ThemeColorType.white}>
          {gettext('Trial expired')}
        </Text12>
      )}
    </StyledDiv>
  );
};

export default TrialInfo;
